<template>
  <div class="col-type-02 mt25 mb30">
    <a class="save-button review fwB fade">
      <p>
        <img
          class="heart"
          :src="`${userCommonImageUrlForPc}/icon_heart.png`"
        >気になる
      </p>
    </a>
    <a
      v-if="isSimple && !isOriginalEntryForm"
      class="simple-entry-button fwB fade"
      data-test="simple"
    >
      <p>
        <img :src="`${userCommonImageUrlForPc}/icon_pr.png`">
        シンプル応募
      </p>
    </a>
    <a
      v-else
      class="entry-button fwB fade"
      data-test="entry"
    >
      <p>
        応募する
      </p>
    </a>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  mixins: [jobPreviewCommon],
  props: {
    isSimple: {
      type: Boolean,
      default: false
    },
    isOriginalEntryForm: {
      type: Boolean,
      default: false
    }
  }
}
</script>
